import { useScrollReveal } from '@/hooks/useScrollReveal';

const Method = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="method-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-narrow">
        <div className="method-content">
          <p className="body-text" data-testid="method-p1">
            I operate at the decision layer. Not the task layer, not the strategy layer &mdash; the layer where you decide what gets your attention and what gets killed.
          </p>

          <p className="body-text mt-8" data-testid="method-p2">
            I look at three things: where your strategy says you&rsquo;re going, where your execution says you&rsquo;re actually going, and the gap between them. I name what&rsquo;s off, what&rsquo;s costing you, and what to do about it &mdash; in that order. Then I give you a 30-day plan with one focus, clear metrics, and a kill trigger so you don&rsquo;t run a failing experiment for six months.
          </p>

          <p className="body-text mt-8" data-testid="method-p3">
            No recurring meetings. No retainer. No 47-slide deck. Mostly async &mdash; Loom, voice notes, docs. Live call when it&rsquo;s needed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Method;
